import { render, staticRenderFns } from "./DuplicateUsers.vue?vue&type=template&id=65ced25a&"
import script from "./DuplicateUsers.vue?vue&type=script&lang=js&"
export * from "./DuplicateUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports